import React from 'react';

interface Props {
  fill?: string;
}

const NoteIcon = ({ fill }: Props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.77778 14.2222H9.77778V9.77778H14.2222V1.77778H1.77778V14.2222ZM1.77778 16C1.28889 16 0.870222 15.8261 0.521778 15.4782C0.173926 15.1298 0 14.7111 0 14.2222V1.77778C0 1.28889 0.173926 0.870222 0.521778 0.521778C0.870222 0.173926 1.28889 0 1.77778 0H14.2222C14.7111 0 15.1298 0.173926 15.4782 0.521778C15.8261 0.870222 16 1.28889 16 1.77778V10.6667L10.6667 16H1.77778ZM3.55556 9.77778V8H8V9.77778H3.55556ZM3.55556 6.22222V4.44444H12.4444V6.22222H3.55556Z" fill={fill || 'black'}/>
    </svg>
  );
};

export default NoteIcon;
